import React from 'react';
import './ExperienceModal.css';

const ExperienceModal = ({ isOpen, onClose, experience }) => {
  if (!isOpen || !experience) return null;

  return (
    <div className="experience-modal-overlay" onClick={onClose}>
      <div className="experience-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="experience-modal-close" onClick={onClose}>×</button>
        
        <div className="experience-modal-header">
          <img src={experience.logo} alt={experience.company} className="experience-modal-logo" />
          <div>
            <h3 className="experience-modal-role">{experience.role}</h3>
            <h2 className="experience-modal-company">{experience.company}</h2>
            <span className="experience-modal-date">{experience.date}</span>
          </div>
        </div>

        <div className="experience-modal-body">
          <div className="experience-modal-description">
            <h3>About this Experience</h3>
            <p>{experience.description}</p>
            {experience.detailedDescription && (
              <p>{experience.detailedDescription}</p>
            )}
          </div>

          <div className="experience-modal-skills">
            <h3>Technologies & Skills</h3>
            <div className="experience-skills-grid">
              {experience.skills.map((skill, index) => (
                <span className="experience-modal-skill" key={index}>{skill}</span>
              ))}
            </div>
          </div>

          {experience.images && experience.images.length > 0 && (
            <div className="experience-modal-gallery">
              <h3>Photos & Highlights</h3>
              <div className="experience-images-grid">
                {experience.images.map((img, index) => (
                  <div key={index} className="experience-image-item">
                    <img src={img.src} alt={img.alt} className="experience-modal-image" />
                    <p className="experience-image-caption">{img.alt}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExperienceModal;